import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backdrop", "panel"]

  open(event) {
    event?.preventDefault()
    this.backdropTarget.classList.remove("hidden")
    this.panelTarget.classList.remove("hidden")
  }

  close(event) {
    event?.preventDefault()
    this.backdropTarget.classList.add("hidden")
    this.panelTarget.classList.add("hidden")
  }

  connect() {
    this._esc = (e) => { if (e.key === "Escape") this.close() }
    window.addEventListener("keydown", this._esc)
  }

  disconnect() {
    window.removeEventListener("keydown", this._esc)
  }
}
